function getTypeIcon(type) {
  const t = (type || '').toLowerCase()
  if (t.includes('annual') || t.includes('vacation')) return '🏖️'
  if (t.includes('sick')) return '🏥'
  if (t.includes('emergency')) return '🚨'
  if (t.includes('maternity') || t.includes('paternity')) return '👶'
  if (t.includes('unpaid')) return '💰'
  if (t.includes('casual')) return '☕'
  if (t.includes('compassion') || t.includes('bereavement')) return '🕊️'
  return '📋'
}

function getBalanceColor(balance) {
  const n = Number(balance)
  if (Number.isNaN(n)) return '#4361ee'
  if (n <= 0) return '#e63946'
  if (n <= 3) return '#f9a826'
  return '#2dc653'
}

function getUsedColor(used) {
  const n = Number(used)
  if (Number.isNaN(n)) return '#4361ee'
  if (n <= 0) return '#8896ab'
  return '#4361ee'
}

function formatHtml(items) {
  if (!items || !items.length) {
    return `
      <div style="text-align:center;padding:24px 0;color:#8896ab;">
        <div style="font-size:40px;margin-bottom:12px;">📭</div>
        <p style="margin:0;font-size:15px;">No leave balance data available</p>
      </div>
    `
  }

  const rows = items
    .map((item, i) => {
      const icon = getTypeIcon(item.type)
      const balColor = getBalanceColor(item.balance)
      const usedColor = getUsedColor(item.used_balance)
      const bgColor = i % 2 === 0 ? '#ffffff' : '#f8f9fc'
      const usedValue = item.used_balance ?? 0

      return `
      <div style="
        display:flex;
        align-items:center;
        padding:14px 18px;
        background:${bgColor};
        border-bottom:1px solid #eef0f7;
      ">
        <div style="
          width:38px;height:38px;border-radius:10px;
          background:rgba(67,97,238,.08);
          display:flex;align-items:center;justify-content:center;
          font-size:18px;flex-shrink:0;margin-right:14px;
        ">${icon}</div>
        <div style="flex:1;min-width:0;">
          <div style="font-weight:600;font-size:14px;color:#2d3748;text-transform:capitalize;">
            ${item.type}
          </div>
        </div>
        <div style="
          display:inline-flex;align-items:center;justify-content:center;
          min-width:52px;height:30px;padding:0 12px;
          margin-right:8px;
          border-radius:8px;
          background:${balColor}18;
          color:${balColor};
          font-weight:700;font-size:14px;
        ">${item.balance}</div>
        <div style="
          display:inline-flex;align-items:center;justify-content:center;
          min-width:52px;height:30px;padding:0 12px;
          border-radius:8px;
          background:${usedColor}18;
          color:${usedColor};
          font-weight:700;font-size:14px;
        ">${usedValue}</div>
      </div>
    `
    })
    .join('')

  return `
    <div style="margin:0 -20px -10px;">
      <div style="
        display:flex;align-items:center;gap:12px;
        padding:16px 18px;
        background:linear-gradient(135deg,#4361ee 0%,#3a0ca3 100%);
        border-radius:10px;
        margin:0 20px 16px;
      ">
        <div style="
          width:40px;height:40px;border-radius:10px;
          background:rgba(255,255,255,.18);
          display:flex;align-items:center;justify-content:center;
          font-size:18px;color:#fff;flex-shrink:0;
        ">⚖️</div>
        <div style="font-size:16px;color:#fff;font-weight:700;">Current Leaves Balance</div>
      </div>

      <div style="
        border-radius:10px;overflow:hidden;
        border:1px solid #eef0f7;
        margin:0 20px;
      ">
        <div style="
          display:flex;align-items:center;
          padding:10px 18px;
          background:#f0f2ff;
          border-bottom:2px solid #dde1f7;
        ">
          <div style="width:52px;flex-shrink:0;"></div>
          <div style="flex:1;font-size:12px;font-weight:600;color:#5a6a85;text-transform:uppercase;letter-spacing:.5px;">
            Leave Type
          </div>
          <div style="min-width:52px;margin-right:8px;text-align:center;font-size:12px;font-weight:600;color:#5a6a85;text-transform:uppercase;letter-spacing:.5px;">
            Balance
          </div>
          <div style="min-width:52px;text-align:center;font-size:12px;font-weight:600;color:#5a6a85;text-transform:uppercase;letter-spacing:.5px;">
            Used
          </div>
        </div>
        ${rows}
      </div>
    </div>
  `
}

export default function currentLeavesBalance(name, swal) {
  swal({
    title: '',
    html: formatHtml(name),
    showCancelButton: false,
    confirmButtonColor: '#4361ee',
    confirmButtonText: '<span style="padding:0 16px;">Close</span>',
    width: 560,
    padding: '24px',
    customClass: {
      popup: 'leaves-balance-popup',
    },
  })
}
